import { omit } from 'lodash'
import { PopFormValues, PopType } from '../types'

export function prepareLinkPopData(values: PopFormValues): PopFormValues {
  if (values.pop_type !== PopType.LinkPop) {
    if (!Object.prototype.hasOwnProperty.call(values.data, 'content')) return values

    const data = { ...values.data }
    delete (data as { content?: string }).content
    return { ...values, data } as PopFormValues
  }

  return {
    ...values,
    is_long_range_pop: true,
    data: {
      ...omit(values.data, ['content', 'pop_image_url', 'video', 'audio', 'pop_video_url', 'pop_audio_url']),
      pop_title: values.data.pop_title.trim(),
      pop_body: values.data.pop_body.trim(),
    },
  }
}
